import React from 'react';

const WeddingTimeline = () => {
  const ceremonies = [
    {
      name: 'Roka',
      icon: (
        <svg className="w-8 h-8" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <circle cx="12" cy="12" r="6" />
          <path d="M12 8l2 2-2 2-2-2z" />
        </svg>
      ),
    },
    {
      name: 'Haldi',
      icon: (
        <svg className="w-8 h-8" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <circle cx="12" cy="12" r="6" />
          <path d="M12 8C8 8 8 12 12 12C16 12 16 16 12 16" />
        </svg>
      ),
    },
{
  name: 'Mehendi',
  icon: (
    <svg className="w-8 h-8" viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      {/* Left Hand */}
      <path d="M16 40V24a2 2 0 0 1 4 0v10" />
      <path d="M20 40V18a2 2 0 0 1 4 0v12" />
      <path d="M24 40V16a2 2 0 0 1 4 0v14" />
      <path d="M28 40V20a2 2 0 0 1 4 0v12" />
      <path d="M16 40c0 6 4 10 8 10s8-4 8-10" />

      {/* Right Hand */}
      <path d="M48 40V24a2 2 0 0 0-4 0v10" />
      <path d="M44 40V18a2 2 0 0 0-4 0v12" />
      <path d="M40 40V16a2 2 0 0 0-4 0v14" />
      <path d="M36 40V20a2 2 0 0 0-4 0v12" />
      <path d="M48 40c0 6-4 10-8 10s-8-4-8-10" />
    </svg>
  ),
}

,
    {
      name: 'Shaadi',
      icon: (
        <svg className="w-8 h-8" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path d="M4 12h16" />
          <path d="M4 12a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8z" />
          <path d="M8 10V6a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4" />
        </svg>
      ),
    },
 {
  name: 'Reception',
  icon: (
    <svg className="w-8 h-8" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="8" width="18" height="13" rx="2" ry="2" />
      <path d="M16 3a4 4 0 0 0-8 0c0 2.2 4 5 4 5s4-2.8 4-5z" />
      <line x1="12" y1="8" x2="12" y2="21" />
    </svg>
  ),
}
,
  ];

  return (
    <div className="relative h-[40vh] bg-[#0B1C3E]"> {/* Changed from min-h-screen to h-[40vh] */}
      {/* Bamboo Forest Background */}
      <div 
        className="absolute inset-0 bg-cover bg-center opacity-20"
        style={{
        backgroundImage: `url('/assets/roka.png')`
        }}
      />

      {/* Vertical Light Lines */}
      <div className="absolute inset-0 overflow-hidden">
        {[...Array(50)].map((_, i) => (
          <div
            key={i}
            className="absolute top-0 w-px bg-gradient-to-b from-transparent via-yellow-100/20 to-transparent"
            style={{
              left: `${i * 2}%`,
              height: '100%',
              opacity: Math.random() * 0.5 + 0.2
            }}
          />
        ))}
      </div>

      {/* Main Content */}
      <div className="relative z-10 container mx-auto px-4 h-full flex items-center">
        <div className="grid grid-cols-5 gap-8 w-full">
          {ceremonies.map((ceremony, index) => (
            <div key={ceremony.name} className="flex flex-col items-center">
              {/* Icon Circle */}
              <div className="w-16 h-16 rounded-full border border-yellow-400/30 flex items-center justify-center mb-4">
                <div className="text-yellow-400">
                  {ceremony.icon}
                </div>
              </div>
              
              {/* Ceremony Name */}
              <span className="text-yellow-400 text-lg font-light">
                {ceremony.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WeddingTimeline;